import { render, staticRenderFns } from "./RequestHistoryLogs.vue?vue&type=template&id=1bf6ded0&scoped=true&"
import script from "./RequestHistoryLogs.vue?vue&type=script&lang=js&"
export * from "./RequestHistoryLogs.vue?vue&type=script&lang=js&"
import style0 from "./RequestHistoryLogs.vue?vue&type=style&index=0&id=1bf6ded0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf6ded0",
  null
  
)

component.options.__file = "RequestHistoryLogs.vue"
export default component.exports